// Auto-ported from the age-of-mcp /gallery. Low-poly parts flattened to a
// self-contained model (no shared helpers, no animations).
import * as THREE from "three";
import { defineModel } from "../../lib";

export const tappedPine = defineModel({
  id: "tapped-pine",
  batchId: "future",
  name: "Tapped pine",
  tags: ["scenery","tapped","pine","low-poly","age-of-mcp","future"],
  summary: "A tapped pine — resin for tar, pitch and turpentine, plus its timber.",
  description: "Ported from the age-of-mcp gallery (future library).",
  author: "age-of-mcp",
  footprint: 0.32,
  variants: [
    { id: "variant-0", label: "Variant 1", parts: () => [
      { geometry: new THREE.CylinderGeometry(0.04, 0.06, 0.07, 6), color: "#523c24", position: [0, 0.035, 0] },
      { geometry: new THREE.CylinderGeometry(0.026, 0.04, 0.5, 6), color: "#6a4e30", position: [0, 0.285, 0] },
      { geometry: new THREE.BoxGeometry(0.01, 0.16, 0.008), color: "#caa86a", position: [0.03, 0.21, 0], rotation: [0, 0, 0.5] },
      { geometry: new THREE.BoxGeometry(0.01, 0.05, 0.008), color: "#caa86a", position: [0.036, 0.26, 0], rotation: [0, 0, -0.5] },
      { geometry: new THREE.BoxGeometry(0.01, 0.05, 0.008), color: "#caa86a", position: [0.036, 0.2, 0], rotation: [0, 0, -0.5] },
      { geometry: new THREE.BoxGeometry(0.01, 0.05, 0.008), color: "#caa86a", position: [0.036, 0.14, 0], rotation: [0, 0, -0.5] },
      { geometry: new THREE.CylinderGeometry(0.022, 0.016, 0.034, 8), color: "#7a7066", position: [0.044, 0.1, 0] },
      { geometry: new THREE.CylinderGeometry(0.018, 0.018, 0.006, 8), color: "#d8a23a", position: [0.044, 0.114, 0] },
      { geometry: new THREE.ConeGeometry(0.15, 0.16, 7), color: "#1f5230", position: [0, 0.575, 0] },
      { geometry: new THREE.ConeGeometry(0.12, 0.13, 7), color: "#2a6a3c", position: [0, 0.66, 0], rotation: [0, 0.4, 0] },
      { geometry: new THREE.ConeGeometry(0.085, 0.1, 7), color: "#1f5230", position: [0, 0.735, 0], rotation: [0, 0.8, 0] },
    ] },
    { id: "variant-1", label: "Variant 2", parts: () => [
      { geometry: new THREE.CylinderGeometry(0.04, 0.06, 0.07, 6), color: "#523c24", position: [0, 0.035, 0] },
      { geometry: new THREE.CylinderGeometry(0.026, 0.04, 0.5, 6), color: "#6a4e30", position: [0, 0.285, 0] },
      { geometry: new THREE.BoxGeometry(0.01, 0.16, 0.008), color: "#caa86a", position: [0.03, 0.21, 0], rotation: [0, 0, 0.5] },
      { geometry: new THREE.BoxGeometry(0.01, 0.05, 0.008), color: "#caa86a", position: [0.036, 0.26, 0], rotation: [0, 0, -0.5] },
      { geometry: new THREE.BoxGeometry(0.01, 0.05, 0.008), color: "#caa86a", position: [0.036, 0.2, 0], rotation: [0, 0, -0.5] },
      { geometry: new THREE.BoxGeometry(0.01, 0.05, 0.008), color: "#caa86a", position: [0.036, 0.14, 0], rotation: [0, 0, -0.5] },
      { geometry: new THREE.CylinderGeometry(0.022, 0.016, 0.034, 8), color: "#7a7066", position: [0.044, 0.1, 0] },
      { geometry: new THREE.CylinderGeometry(0.018, 0.018, 0.006, 8), color: "#d8a23a", position: [0.044, 0.114, 0] },
      { geometry: new THREE.ConeGeometry(0.15, 0.16, 7), color: "#1f5230", position: [0, 0.575, 0], rotation: [0, 1.4, 0] },
      { geometry: new THREE.ConeGeometry(0.12, 0.13, 7), color: "#2a6a3c", position: [0, 0.66, 0], rotation: [0, 1.8, 0] },
      { geometry: new THREE.ConeGeometry(0.085, 0.1, 7), color: "#1f5230", position: [0, 0.735, 0], rotation: [0, 2.2, 0] },
    ] },
  ],
  animations: [],
});
